import React from "react";
import { ErrorBoundary } from "@catchoftheday/cg-components";
import { Snowplow } from "@catchoftheday/analytics";
import { Header } from "../components/Header";
import { jsx as ___EmotionJSX } from "@emotion/react";

var Home = function Home(_ref) {
  var headerConfiguration = _ref.headerConfiguration;

  var renderHeader = function renderHeader() {
    return ___EmotionJSX(Header, {
      headerConfiguration: headerConfiguration
    });
  };

  var snowplowConfig = headerConfiguration === null || headerConfiguration === void 0 ? void 0 : headerConfiguration.snowplowConfig;
  return ___EmotionJSX(ErrorBoundary, {
    FallbackComponent: function FallbackComponent() {
      return renderHeader();
    }
  }, snowplowConfig ? ___EmotionJSX(Snowplow, {
    config: snowplowConfig,
    disableAutomaticTracking: true
  }) : null, renderHeader());
};

Home.getInitialProps = function (_ref2) {
  var query = _ref2.query;
  var headerConfiguration = query.initialData;
  return {
    headerConfiguration: headerConfiguration
  };
};

export default Home;